export default __webpack_public_path__ + "images/assets/13c222fca21f05256ca98d347063ab19.svg";